export default {
  en: {
    'bank': 'bank',
    'rewards': 'rewards',
    'transfer': 'transfer',
    'wages': 'wages',
    '': '',
  }
}